import brands from './reducers/brands';
import categories from './reducers/category';
import profile from './reducers/profile';
import products from './reducers/products';
import orders from './reducers/orders';
import locations from './reducers/locations';
import pending from './reducers/pending';
import appBlocked from './reducers/appBlocked';

import { combineReducers } from 'redux'
import dashboard from './reducers/dashboard';
import contactUs from './reducers/contactUs';
import users from './reducers/users';
import gallery from './reducers/gallary';

const RouteReducers = combineReducers({
  brands,
  categories,
  users,
  profile,
  products,
  orders,
  locations,
  pending,
  appBlocked,
  dashboard,
  contactUs,
  gallery,
});

export default RouteReducers;